<template>
  <div class="container">
    <div class="alert alert-info" role="alert">
      {{$t("Récupération du mot de passe pour l'utilisateur :")}} {{user.email}} ({{user.login}})
    </div>
    <div v-if="token === undefined || token.length == 0" class="alert alert-danger" role="alert">
      {{$t("Le lien est invalide. Impossible de réinitialiser votre mot de passe.")}}
    </div>
    <div v-if="showSuccess" class="alert alert-success" role="alert">
      {{$t("Mot de passe modifié avec succès.")}}
    </div>
    <div v-if="showError" class="alert alert-danger" role="alert">
      {{$t("Impossible de modifier votre mot de passe.")}}
    </div>
    <div v-if="!isPwdValid()" class="alert alert-danger" role="alert">
      {{$t("Veuillez vous assurer que les deux champs sont identiques.")}}
    </div>
    <div v-if="token !== undefined && token.length > 0 && showSuccess === false"  action="#" class="row justify-content-center">
      <div class="col-sm-10 col-md-8">
        <div class="form-row">
          <div class="col-12 form-group">
            <input type="password" class="form-control" v-bind:placeholder="$t('Mot de passe')" v-model="pwd1">
          </div>
          <div class="col-12 form-group">
            <input type="password" class="form-control" v-bind:placeholder="$t('Confirmation du mot de passe')" v-model="pwd2">
          </div>
       </div>
      </div>
      <div class="col-12 text-center mt-2 mt-md-4">
        <button class="btn btn-primary ml-2" @click="modifyPwd">{{$t("Sauver mot de passe")}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import i18n from '@/i18n';
export default {
    setup() {
      const route = useRoute();
      var token = ref("");
      const user = ref("");
      var lang = route.query.lang;
      if (lang !== undefined) {
          i18n.global.locale.value = lang;
      }
      let userTokenFormData = new FormData();
      userTokenFormData.append('token', route.query.token);
      userTokenFormData.append('lang', i18n.global.locale.value);
      fetch("api/getuserbytoken", {
          body: userTokenFormData,
          method: "post"
      }).then(function(resp) {
        resp.json().then(function(json) {
          user.value = json;
          token.value = route.query.token;
        }.bind(this));
      }.bind(this));

      const showSuccess = ref(false);
      const showError = ref(false);
      const pwd1 = ref("");
      const pwd2 = ref("");
      const modifyPwd = function() {
        if (pwd1.value === pwd2.value && token.value.length > 0) {
          let formData = new FormData();
          formData.append('password', pwd1.value);
          formData.append('token', token.value);
          formData.append('lang', i18n.global.locale.value);
          fetch("api/modifyPwd", {
              body: formData,
              method: "post"
          }).then(function(resp) {
                resp.json().then(function(status) {
                    if ('success' in status && status.success == true) {
                        showSuccess.value = true;
                        pwd1.value = '';
                        pwd2.value = '';
                    } else {
                        showError.value = true;
                        setTimeout(function () {
                            showSuccess.value = false;
                        }, 5000);
                    }
                });
            });
        }
      }
      const isPwdValid = function() {
        return (pwd1.value == pwd2.value);
      }
      return {
        showSuccess,
        isPwdValid,
        modifyPwd,
        pwd1,
        pwd2,
        token,
        user
      }
    }
}
</script>
